import { Typography } from "@mui/material";
import React from "react";
import LoadingDots from "./LoadingDots";

export const LoadingLive = () => {
  return (
    <div className="bg-black h-custom-live flex flex-col items-center justify-center text-center p-4">
      <div className="flex flex-col items-center">
        <img
          className=""
          src="/asset/DoubleRing.svg"
          width={200}
          // height={10}
          alt="Live Icon"
        />
        <Typography
          variant="h6"
          className="text-gray-300 font-semibold mt-4"
          sx={{
            fontSize: {
              xs: "1rem", // Ukuran untuk layar kecil
              sm: "1.25rem", // Ukuran untuk layar sedang
              md: "1.5rem", // Ukuran untuk layar besar
            },
          }}
        >
          <LoadingDots />
        </Typography>
        {/* <Typography
          variant="body2"
          className="text-gray-400 mt-2"
          sx={{
            fontSize: {
              xs: "0.875rem", // Responsif untuk teks kecil
              sm: "1rem",
              md: "1.125rem",
            },
          }}
        >
          Video sedang dimuat
        </Typography> */}
      </div>
    </div>
  );
};
